// extracted by mini-css-extract-plugin
export default {"publishedDate":"PublishedDate-module--publishedDate--de7e9","left":"PublishedDate-module--left--fe5ff","center":"PublishedDate-module--center--56bdb"};